import { InitializeTemperature } from '../../ProfilesTabs/helpers/InitializeTemperature';
import { propertyToggle } from '../../../utils/helpers';

export function transformAvailabilityToPayload(availabilityItem) {
  const availabilityParse: any = {};
  availabilityParse.id = availabilityItem.id;
  availabilityParse.country_id = propertyToggle(
    availabilityItem.country_id !== 'all',
    availabilityItem.country_id,
    null,
  );
  availabilityParse.region = availabilityItem.region;
  availabilityParse.state_id = propertyToggle(
    availabilityItem.state_id !== 'all',
    availabilityItem.state_id,
    null,
  );
  availabilityParse.holdingMax =
    availabilityItem['formTemperatures'].tempMaxF * 1;
  availabilityParse.holdingMin =
    availabilityItem['formTemperatures'].tempMinF * 1;
  return availabilityParse;
}

export const availabilityToFormSerializer = availability => {
  if (availability) {
    availability.formTemperatures = {
      tempMin: availability.holdingMinC,
      tempMax: availability.holdingMaxC,
      tempMinF: availability.holdingMinF,
      tempMaxF: availability.holdingMaxF,
    };
  } else {
    availability.formTemperatures = { ...InitializeTemperature() };
  }
  return availability;
};
export const formtoTemperaturesSerializer = availability => {
  if (availability.formTemperatures) {
    availability = {
      ...availability,
      holdingMaxF: availability.formTemperatures.tempMaxF,
      holdingMinF: availability.formTemperatures.tempMinF,
      holdingMinC: availability.formTemperatures.tempMin,
      holdingMaxC: availability.formTemperatures.tempMax,
    };
  } else {
    availability.formTemperatures = InitializeTemperature();
  }
  return availability;
};
export const VIEW_MODE_STATES = {
  EDIT: 'EDIT',
  CREATE: 'CREATE',
  CLONE: 'CLONE',
  LIST: 'LIST',
  READ: 'READ',
  SEARCH: 'SEARCH',
};
